// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","275":"Product"}[chunkId] + "." + {"72":"974b9edc","187":"af6e6c27","275":"2ae4f134"}[chunkId] + ".chunk.js";
};